import { DeleteSection } from '../types';
import { select } from 'redux-saga/effects';
import { MultipleOpinionScaleQuesState } from '../../../../../shared/types/QuesTypes';
import { putEffect } from '../../../../../shared/utils/putEffect';
import { setSurveyError } from '../../shared/actions';
import { getApiError } from '../../../../../shared/utils/getApiError';
import axios from '@utils/axios';
import { getApiEndPointUrl } from '../../../../../shared/utils/getApiEndpointUrl';
import { questionSectionsEndPoint } from '../consts';
import { omit, without } from 'ramda';
import { setQuestion } from '../../sharedQuestions/actions';
import { set, updateAll } from 'shades';

export function* removeSection(action: DeleteSection) {
	const { quesId, sectionId } = action.payload;
	const { questions } = yield select((s) => s.surveyBuilder);
	if (!!questions[quesId]) {
		const question: MultipleOpinionScaleQuesState = questions[quesId];

		try {
			yield axios.delete(getApiEndPointUrl(questionSectionsEndPoint, sectionId));
			const sectionOrder = without([sectionId], question.settings.sectionOrder);
			yield putEffect(
				setQuestion(
					question.id,
					updateAll<MultipleOpinionScaleQuesState>(
						set('settings', 'sectionOrder')(sectionOrder),
						(questionState) =>
							sectionOrder.reduce(
								(question, sectionId, index) => set('sections', sectionId, 'orderPosition')(index + 1)(question),
								questionState
							),
						set('sections')(omit([sectionId], question.sections))
					)(question)
				)
			);
		} catch (e) {
			yield putEffect(setSurveyError(getApiError(e)));
		}
	} else {
		let question: any;
		for (const questionId in questions) {
			const section = questions[questionId];
			if (section?.metaData && section?.questionnaireId.length > 0) {
				if (section?.questions?.[quesId]) {
					question = section?.questions?.[quesId];
					break;
				}
			}
		}
		try {
			yield axios.delete(getApiEndPointUrl(questionSectionsEndPoint, sectionId));
			const sectionOrder = without([sectionId], question.settings.sectionOrder);
			questions[question?.questionnaireSectionId].questions[question.id] = updateAll<MultipleOpinionScaleQuesState>(
				set('settings', 'sectionOrder')(sectionOrder),
				(questionState) =>
					sectionOrder.reduce(
						(question, sectionId, index) => set('sections', sectionId, 'orderPosition')(index + 1)(question),
						questionState
					),
				set('sections')(omit([sectionId], question.sections))
			)(question);

			yield putEffect(setQuestion(question?.questionnaireSectionId, questions[question?.questionnaireSectionId]));
		} catch (e) {
			yield putEffect(setSurveyError(getApiError(e)));
		}
	}
}
